/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import { useAction } from '../../../Common/hooks';
import { oneSecond } from '../../../Common/constants';
import { getAggregatorOptions, getPayerOptions } from '../../services';
import { setReasonFilters } from '../../actions';
import { getReasonFilters } from '../../selectors';
import { reasonFiltersInitialState } from '../../reducers';
import { dropDownDefault } from '../../services/constants';

const useReasonFilterBar = () => {
  const storeFilters = useSelector(getReasonFilters);
  const setStoreFilters = useAction(setReasonFilters);
  const debouncedFilterChange = useCallback(debounce(setStoreFilters, oneSecond), []);
  const [aggregatorOptions, setAggregatorOptions] = useState(dropDownDefault);
  const [payerOptions, setPayerFilterOptions] = useState([]);
  const [showResetButton, setShowResetButton] = useState(false);
  const [filters, setFilters] = useState({ ...storeFilters });

  useEffect(() => {
    const callFilterOptions = async () => {
      const aggregatorFilterOptions = await getAggregatorOptions();

      setAggregatorOptions(aggregatorFilterOptions);
    };

    callFilterOptions();

    return () => setStoreFilters({ ...reasonFiltersInitialState });
  }, []);

  useEffect(() => {
    debouncedFilterChange(filters);
    setShowResetButton(!isEqual(filters, reasonFiltersInitialState));
  }, [filters]);

  const updatePayerFilterOptions = async value => {
    const payersOptionsPerAggregatorID = await getPayerOptions(value);
    setPayerFilterOptions(payersOptionsPerAggregatorID);
  };

  const handleFilterChanges =
    filterName =>
    ({ target: { value } }) => {
      let filter = { [filterName]: value };

      if (filterName === 'aggregatorID') {
        setPayerFilterOptions([]);
        updatePayerFilterOptions(value);
        filter = { ...filter, payerID: '' };
      }

      setFilters({
        ...filters,
        ...filter,
      });
    };

  const handleResetFilter = () => {
    setFilters({ ...reasonFiltersInitialState });
    setPayerFilterOptions([]);
  };

  return {
    aggregatorOptions,
    payerOptions,
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    filters,
  };
};

export default useReasonFilterBar;
